// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10SEs","controls":"styles_controls__1CbHZ","charLimit":"styles_charLimit__34ZHq","input":"styles_input__3RL8t","send":"styles_send__3JM_O"};